import { useCallback, useEffect, useState } from "react";

const KEY = "tsm_reading_mode";
const MODE_EVENT = "tsm-reading-mode-change";

function read() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" ? "light" : "dark";
  } catch (e) {
    return "dark";
  }
}

function apply(mode) {
  const root = document.documentElement;
  root.classList.toggle("dark", mode === "dark");
  root.style.colorScheme = mode === "dark" ? "dark" : "light";
}

/** Persisted light (broadsheet) / dark (dossier) reading mode. */
export default function useReadingMode() {
  const [mode, setMode] = useState(read);

  useEffect(() => {
    apply(mode);
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {
      /* storage disabled */
    }
  }, [mode]);

  useEffect(() => {
    const syncMode = (event) => setMode(event.detail);
    window.addEventListener(MODE_EVENT, syncMode);
    return () => window.removeEventListener(MODE_EVENT, syncMode);
  }, []);

  const toggle = useCallback(
    () => {
      const next = document.documentElement.classList.contains("dark") ? "light" : "dark";
      apply(next);
      setMode(next);
      window.dispatchEvent(new CustomEvent(MODE_EVENT, { detail: next }));
    },
    []
  );

  return { mode, setMode, toggle, isDark: mode === "dark" };
}
